import React from "react"
import Radium from "radium"

const _blueButton = (disabled) => ({
    cursor: 'pointer',
    display: 'inline-block',
    minHeight: '1em',
    outline: 0,
    border: '1px solid #5e93bf',
    verticalAlign: 'baseline',
    backgroundColor: disabled ? '#D3D3D3' : 'transparent',
    color: "#5e93bf",
    fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
    margin: '0 .25em 0 0',
    padding: 8,
    textTransform: 'none',
    textShadow: 'none',
    fontWeight: 700,
    lineHeight: '1em',
    fontStyle: 'normal',
    textAlign: 'center',
    textDecoration: 'none',
    borderRadius: '.28571429rem',
    boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
    transition: 'opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease',
    ':hover':{
        backgroundColor: 'rgba(0,0,0,0.05)',
        boxShadow: '0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset',
    },
    ':active': {
        backgroundColor: 'rgba(0,0,0,0.1)',
    },
    ':disabled': {
        border:'1px solid transparent'
    }

})

const WhiteDownButton = ({text, style, disabled, onClick }) => {
    return (
        <button style={{..._blueButton(disabled), ...style}} disabled={disabled} onClick={(e) => {e.preventDefault();onClick()}}>{text}</button>
    )
}

export default Radium(WhiteDownButton)